import { toast } from "sonner";
import request from "../../../helpers/request";

export const deleteAlertasUsuariosEncaminhados = async (
  nome,
  idLoja,
  idCliente,
) => {
  const url = `${process.env.REACT_APP_API}/Alerta/DeleteEncaminhados?nome=${nome}&idLoja=${idLoja}&idCliente=${idCliente}`;
  const result = await request({
    url,
    method: "get",
  });

  console.log("deleteAlertasUsuariosEncaminhados", result);
  return result.data;
};
